import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'

class Layout extends Component {
  render () {
    return (
      <div className={`${this.props.data && this.props.data.selectedSong ? 'pb-24' : ''}`}>
        {this.props.children}
        <div className='bg-upton-100 pr-4 pl-4'>
          <div className='mx-auto container flex lg:flex-row flex-col h-24 items-center lg:justify-between justify-center'>
            <div>
              <Link className='uppercase font-bold text-white text-sm mr-6' to='/terms'>Terms &amp; Conditions</Link>
              <Link className='uppercase font-bold text-white text-sm' to='/privacy'>Privacy Policy</Link>
            </div>
            <p className='uppercase font-bold text-white text-sm mt-4 lg:mt-0'>&copy; Upton Priory PTFA</p>
          </div>
        </div>
      </div>

    )
  }
}

const mapStateToProps = ({ data }) => ({
  data
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Layout))
